import { createContext, useContext, useEffect, useState } from "react";
import { supabaseClient } from "../components/supabaseClient";
import { User } from "@supabase/supabase-js";

const AuthContext = createContext({});

export const useAuth = () => useContext(AuthContext);

const login = (email: string, password: string) =>
    supabaseClient.auth.signInWithPassword({ email, password });

const signOut = () => supabaseClient.auth.signOut();


const AuthProvider = ({ children }: { children: React.ReactNode }) => {
    const [loading, setLoading] = useState(false);
    const [user, setUser] = useState<User | null>(null);
    const [auth, setAuth] = useState(false);

    useEffect(() => {
        const { data } = supabaseClient.auth.onAuthStateChange((event, session) => {
            if (event === "SIGNED_IN") {
                setUser(session?.user ?? null);
                setAuth(true);
            } else if (event === "SIGNED_OUT") {
                setUser(null);
                setAuth(false);
            }
        });
        return () => {
            data.subscription.unsubscribe();
        };
    }, []);

    useEffect(() => {
        setLoading(true);
        const getUser = async () => {
          const { data } = await supabaseClient.auth.getUser();
          const { user: currentUser } = data;
          setUser(currentUser ?? null);
          setLoading(false);
        };
        getUser();
      }, []);

    return (
        <AuthContext.Provider value={{ auth, user, login, signOut }}>{!loading && children}</AuthContext.Provider>
    );
};

export default AuthProvider;